import { selectors, useAppSelector } from 'state/global-state';

import { useCheckoutContext } from './use-checkout-context';

export const useCheckoutLoadingState = () => {
  const {
    isSubmittingOrder,
    isBuildingCommitOrderPayload,
    isLoadingPaymentMethods,
    isOrderLoading,
    isMenuLoading,
    isSelectingStore,
    isFetchingStore,
  } = useCheckoutContext();

  // Read the pricing state from Redux (set by price order)
  const isPricingOrderFromCart = useAppSelector(selectors.ordering.selectIsPricingOrder);

  // Combine local order loading state with cart pricing state
  const isOrderPriceLoading = isOrderLoading || isPricingOrderFromCart;

  return {
    isOrderPriceLoading,
    isSubmittingOrder,
    isBuildingCommitOrderPayload,
    isLoadingPaymentMethods,
    isCheckoutLoading:
      isOrderPriceLoading ||
      isSubmittingOrder ||
      isBuildingCommitOrderPayload ||
      isLoadingPaymentMethods ||
      isMenuLoading ||
      isSelectingStore ||
      isFetchingStore,
  };
};
